"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faSpinnerThird_1 = require("@fortawesome/pro-regular-svg-icons/faSpinnerThird");
const Label_1 = __importDefault(require("../../components/Label"));
const withSpacing_1 = __importDefault(require("../../hoc/withSpacing"));
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const testUtils_1 = require("../../utils/testUtils");
const styles = require('./Input.module.scss');
const Input = (_a, ref) => {
    var { classes: { icon: iconClassName = '', input: inputClassName = '', label: labelClassName = '', labelTextWrapper: labelTextWrapperClassName = '', root: rootClassName = '', } = {}, defaultValue, hasError, hideOptionalLabelText, icon, id, isLabelHidden, isLoading, isRequired, label, onIconClick, placeholder, trackingAttributes, typeIdOptions } = _a, rest = __rest(_a, ["classes", "defaultValue", "hasError", "hideOptionalLabelText", "icon", "id", "isLabelHidden", "isLoading", "isRequired", "label", "onIconClick", "placeholder", "trackingAttributes", "typeIdOptions"]);
    const iconClassNames = (0, classnames_1.default)(styles.icon, { [iconClassName]: !!iconClassName });
    return (react_1.default.createElement(Label_1.default, { className: labelClassName, classes: { labelTextWrapper: labelTextWrapperClassName }, hidden: isLabelHidden, hideOptionalText: hideOptionalLabelText, htmlFor: id, isRequired: isRequired, label: label },
        react_1.default.createElement("span", { className: (0, classnames_1.default)(styles.inputWrapper, { [rootClassName]: !!rootClassName }) },
            icon && (react_1.default.createElement("span", { className: styles.iconWrapper }, isLoading ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { spin: true, icon: faSpinnerThird_1.faSpinnerThird, className: iconClassNames })) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: iconClassNames, onClick: onIconClick })))),
            react_1.default.createElement("input", Object.assign({ className: (0, classnames_1.default)(styles.input, {
                    [styles.error]: hasError,
                    [inputClassName]: !!inputClassName,
                    [styles.inputRightPadding]: !!icon,
                }), defaultValue: defaultValue, id: id, placeholder: placeholder, ref: ref }, (isLabelHidden && { 'aria-label': label }), (0, analyticsUtils_1.getTrackingAttributes)(trackingAttributes), (0, testUtils_1.getDataTypeAttribute)(typeIdOptions), rest)))));
};
exports.default = (0, withSpacing_1.default)((0, react_1.forwardRef)(Input));
//# sourceMappingURL=Input.js.map